import { defineMessages } from 'react-intl';

const messages = defineMessages({
  noPagination: {
    id: 'Listing no pagination',
    defaultMessage: 'No paginar (mostrar tots els elements)',
  },
});

export const blogListingSchemaEnhancer = ({ schema, intl }) => {
  if (!schema.fieldsets?.[0]?.fields.includes('noPagination')) {
    schema.fieldsets[0].fields.push('noPagination');
  }

  schema.properties.noPagination = {
    title: intl.formatMessage(messages.noPagination),
    type: 'boolean',
    default: false,
  };

  return schema;
};
